export default "__VITE_ASSET__72f41346__"